import React from 'react';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

const NonAccessibleModal = ({
  isModuleNotAccessed,
  handleCloseAccessModule,
  classes
}) => {
  return (
    <Modal
      open={isModuleNotAccessed}
      onClose={handleCloseAccessModule}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
    >
      <Box className={classes.planWrapper}>
        <Grid container justifyContent='flex-end' alignItems='flex-end'>
          <Grid item sm={12} style={{ textAlign: 'end' }}>
            <IconButton aria-label='Close' onClick={handleCloseAccessModule}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Typography variant='subtitle1'>
          You don't have access to view this module
        </Typography>
        <Box>
          <Button
            variant='contained'
            color='secondary'
            fullWidth
            disableElevation
            onClick={handleCloseAccessModule}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NonAccessibleModal;
